import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import EcomSellerDashboard from "./pages/Ecommerce/EcomSellerDashboard/EcomSellerDashboard";
import EcomSellerDetails from "./pages/Ecommerce/EcomSellerLogin/EcomSellerDetails";
import Frontpage from "./pages/Ecommerce/Frontpage";
import EcomSellerConfirmation from "./pages/Ecommerce/EcomSellerLogin/EcomSellerConfirmation";
import EcomSellerLogin from "./pages/Ecommerce/EcomSellerLogin/EcomSellerLogin";
import "./styles.scss"
import EcomproductView from "./pages/Ecommerce/EcomSellerDashboard/Components/EcomproductView";
import Products from "./pages/Ecommerce/EcomSellerDashboard/Components/Products";
import Overview from "./pages/Ecommerce/EcomSellerDashboard/Components/Overview";
import AddProduct from "./pages/Ecommerce/EcomSellerDashboard/Components/AddProduct";
import HelpLine from "./pages/Ecommerce/EcomSellerDashboard/Components/HelpLine";
import Orders from "./pages/Ecommerce/EcomSellerDashboard/Components/Orders";
import BankAccount from "./pages/Ecommerce/EcomSellerDashboard/Components/BankAccount";
import ProductEdit from "./pages/Ecommerce/EcomSellerDashboard/Components/ProductEdit";
import AddProperties from "./pages/Ecommerce/EcomSellerimageedit/AddProperties";
import ProductimageEdit from "./pages/Ecommerce/EcomSellerimageedit/ProductimageEdit";
import ResellerNavbar from "./components/ResellerNavbar";
import LandingPage from "./pages/Ecommerce/EcomSellerDashboard/Components/LandingPage";
import ContactUs from "./components/ContactUs/ContactUs";
import { useSelector } from "react-redux";
import ErrorPage from "./pages/Ecommerce/EcomSellerDashboard/Components/ErrorPage";

function App() {
  const state = useSelector((state) => state.sellers);
  const { sellerAuth } = state;
  const seller=  localStorage.getItem("sellerregisterInfo");
  const sellerInfoObject = JSON.parse(seller);
  return (
    <React.Fragment>
      <Router>
        <Routes>
          {sellerInfoObject?(<>
            <Route path="/" element={<LandingPage/>} />
          <Route path="/contactus" element={<ContactUs/>} />

          <Route path="/login" element={<EcomSellerLogin/>} />
          <Route path="/Reseller" element={<LandingPage/>} />
          <Route path="/register" element={<EcomSellerDetails/>} />
          <Route path="/confirmation" element={<EcomSellerConfirmation/>} />
          <Route path="/dashboard" element={ <Overview/>} />
          <Route path="/ecomproductview/:id" element={<EcomproductView/>} />
          <Route path="/imageedit/:id" element={<EcomproductView/>} />
          <Route path="/productlist" element={ <Products/> } />
          <Route path="/overview" element={ <Overview/> } />
          <Route path="/addproduct" element={ <AddProduct />} />
          <Route path="/helpline" element={ <HelpLine/>} />
          <Route path="/orders" element={ <Orders/>} />
          <Route path="/addbankaccount" element={ <BankAccount/>} />
          <Route path="/productedit/:id" element={ <ProductEdit/>} />
          <Route path="/addproperties/:id" element={<AddProperties />} />
          <Route path="/productimageedit/:id" element={<ProductimageEdit/>} />

          </>):(<>
            <Route path="/" element={<LandingPage/>} />
            <Route path="/login" element={<EcomSellerLogin/>} />
            <Route path="/*" element={<ErrorPage />} />
          </>)}
          {/* <Route path="/Ecomsignup" element={<Signup />} /> */}
          

          {/* <Route path="/customsignup" element={<Customsignup />} />
          <Route path="/login" element={<Login />} />
          <Route path="/NextPage" element={<Product />} />
          <Route path="/customlogin" element={<CustomLogin />} />
          <Route path="/home" element={<Home />} />
          <Route path="/chat" element={<Chat />} />
          <Route path="/products" element={<Product />} />
          <Route path="/ecomproducts" element={<Customproduct />} />
          <Route path="/chatuser" element={<ResellerChat />} />
          <Route path="/resellermessage" element={<SellerMessages />} />
          <Route path="/new" element={<Newcomp/>} />
          <Route path="/emoji" element={<Emoji/>} />
          <Route path="/size" element={<Size/>} />
          <Route path="/chatuser/:id" element={<Singleconv/>} />
          <Route path="/chatuser/notification" element={<Notification/>} />
          <Route path="/calender" element={<Datepicker/>} />
          <Route path="/creativestudio" element={<Creativestudio/>} />
          <Route path="/list" element={<List/>} />
          <Route path="/orders" element={<Order/>} />
          <Route path="/prolist" element={<Prductlist/>} />
          <Route path="/Ecom" element={<EcomProduct/>} />
          <Route path="/trial" element={<TrialOtp/>} />
          <Route path="/addproduct" element={<AddProduct/>} />
          <Route path="/sellermainpage" element={<SellerMainpage/>} /> */}
        </Routes>
      </Router>
    </React.Fragment>
  );
}

export default App;
